import http from '../plugins/axios'

export const getAllNewsList = async (params) => {
  try {
    const response = await http.get(`/api/v2/admin/news`, { params })
    return response.data
  } catch(error) {
    throw error
  }
}

export const addAdminNews = async (payload) => {
  try {
    const response = await http.post(`/api/v2/admin-news`, payload)
    return response.data
  } catch(error) {
    throw error
  }
}

export const deleteAdminNews = async (userLoginId, newsId) => {
  try {
    const response = await http.delete(`api/v2/admin/${userLoginId}/news/${newsId}`)
    return response.data
  } catch(error) {
    throw error
  }
}